import { init } from '@dash0/sdk-web'
import escapeRegExp from 'lodash/escapeRegExp'
import posthog from 'posthog-js'
import { API_CONFIG } from '@/lib/config/api'
import { isServicesHostname } from '@/lib/config/spaces'

const isProduction = process.env.NEXT_PUBLIC_ENV === 'production'

if (process.env.NEXT_PUBLIC_OTEL_ENABLED === 'true') {
  init({
    serviceName: 'plateforme-web',
    serviceNamespace: 'la-plateforme',
    serviceVersion: process.env.NEXT_PUBLIC_COMMIT_ID,
    environment: process.env.NEXT_PUBLIC_ENV,
    endpoint: {
      url: process.env.NEXT_PUBLIC_DASH0_ENDPOINT!,
      authToken: process.env.NEXT_PUBLIC_DASH0_AUTH_TOKEN!,
    },
    // Cross-origin, so the API has to be named explicitly for the browser span and the
    // backend trace it triggers to end up in the same trace.
    propagators: [
      {
        type: 'traceparent',
        match: [new RegExp(`^${escapeRegExp(API_CONFIG.BASE_URL)}`)],
      },
    ],
  })
}

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_API_KEY!, {
  ...(process.env.NEXT_PUBLIC_POSTHOG_HOST
    ? { api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST }
    : {}),
  // On the Services host nothing is stored in the browser, so the measurement needs no consent
  // banner; the sign-in identifies the account on every page load instead of a cookie.
  ...(isServicesHostname(window.location.hostname)
    ? { persistence: 'memory' as const, disable_session_recording: true }
    : {}),
  person_profiles: 'always',
  defaults: '2025-05-24',
  autocapture: isProduction,
  capture_pageview: false,
  capture_exceptions: isProduction,
  capture_performance: isProduction,
  loaded: posthog => {
    posthog.register({
      environment: process.env.NEXT_PUBLIC_ENV || 'development',
      source: 'frontend',
      service: 'frontend',
    })
  },
})
